// Setup › Memory & privacy at `/c/{slug}/setup/memory-privacy` (managers, the `memory` add-on):
// features/memory/memory-privacy-screen. While the add-on is off a direct URL says "not enabled".
import { createRoute } from "@tanstack/react-router";
import { MemoryPrivacyScreen } from "../features/memory/memory-privacy-screen";
import { useCompany, useFeature } from "../features/use-feature";
import { NotEnabledPage } from "../pages/status-pages";
import { setupRoute } from "./c.$slug.setup";

export const setupMemoryPrivacyRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "memory-privacy",
  component: function MemoryPrivacy() {
    const { api } = setupMemoryPrivacyRoute.useRouteContext();
    const company = useCompany();
    const memory = useFeature("memory");
    if (!memory.enabled)
      return (
        <NotEnabledPage
          what="Memory & privacy"
          feature="memory"
          companyName={company.name}
          slug={company.slug}
        />
      );
    return <MemoryPrivacyScreen api={api} company={company} />;
  },
});
